import {ResourceInvalidationTriggers} from "../../global/resourcemanager/resourceManager";
import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {INTERFRAMEMESSAGES} from "../../global/InterframeMessages";
import {type AjaxSettings, JQueryAjaxConnector} from "../../global/ajaxConnector";
import globalsObject from "../globalsObject";
import {IResourceManager} from "../../global/resourcemanager/IResourceManager";
import {LoginResponse} from "../databaseInterfaceClasses";

export class LoginSuccessfulResult {
    username:string;
    loginResponse:{email:string, telefon:string, lieferland:string};
    callback:()=>void;
    status : string;

    public constructor(loginResponse:LoginResponse, callback = function(){}) {
        this.username = loginResponse.login;
        this.loginResponse = loginResponse;
        this.status = loginResponse.status;
        this.callback = callback;
    }
}

export class AccountController extends EventListener{
    private readonly resourceManager: IResourceManager;
    private readonly sprache:string;
    private readonly land:string;

    private static readonly LOGIN_URL = "/konfigurator_php/sessiondata/login.php";

    public constructor(resourceManager: IResourceManager, sprache:string, land:string) {
        super();
        this.sprache = sprache;
        this.land = land;
        this.resourceManager = resourceManager;
        this.initEventHandlers();
        this.initClickHandlers();
    }

    private initEventHandlers() {
        this
			.addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_SUCCESS, (data)=>this.loginSuccessful(data))
            .addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_FAIL, ()=>this.loginFailed())
    }


    private loginSuccessful(data:{loginResponse:LoginResponse}) {

        if (data.loginResponse.status !== "success") {
            this.loginFailed();
            return;
        }
        this.resourceManager.getOrRegisterResource("userLoggedIn").addState("successful").invalidAfter(ResourceInvalidationTriggers.USERCHANGED);
    }

    private loginFailed() {
        this.resourceManager.executeInvalidation("loginFailed");
        this.resourceManager.getOrRegisterResource("userLoggedIn").addState("failed").invalidAfter(ResourceInvalidationTriggers.USERCHANGED);
    }

    static loginCancelled() {
        if (globalsObject.resourceManager.resourceHasState("userLoggedIn", "initialized")) {
            return;
        }
        globalsObject.resourceManager.getOrRegisterResource("userLoggedIn").addState("failed");
        globalsObject.resourceManager.executeInvalidation("loginFailed");
    }

    public loginOnPageLoad(username: string, password: string, onSuccess?: () => void) {
        const $this = this;
        this.resourceManager.getOrRegisterResource("userLoggedIn").addState("initialized");
        JQueryAjaxConnector.send(
            AccountController.getLoginAjaxSettings(username, password, this.sprache, this.land),
            function (data) {
                EventVerteiler.broadcast(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_SUCCESS, new LoginSuccessfulResult(data, onSuccess));
            },
            () => $this.loginFailed()
        );
    }

    private static getLoginAjaxSettings(username: string, password: string, sprache:string, land:string):AjaxSettings {
        return JQueryAjaxConnector.getSettings(
            AccountController.LOGIN_URL,
            {
                username: username,
                password: password,
                language: sprache,
                land: land
            }
        );
    }

    private initClickHandlers() {
        $('#ausloggen, #accountinfo-ausloggen').click(function () {
            EventVerteiler.broadcast(INTERFRAMEMESSAGES.LOGOUT_REQUESTED);
        });
    }
}
